import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getScheduleList, getSharedScheduleList } from '../clients/gateway.api';
import { getReachInformationForScheduleId } from '../clients/reachInformation.api';

interface GetScheduleListParams {
    imo: string;
    etdFrom?: string;
    etdTo?: string;
    customerGroupId?: string;
}

interface ScheduleReachInformationParams {
    vesselId: string;
    scheduleId: string;
}

export const schedules = createQueryKeys('schedules', {
    list: (params: GetScheduleListParams) => ({
        queryKey: [{ params }],
        queryFn: () => getScheduleList(params),
    }),
    withPrices: (imo: string) => ({
        queryKey: [imo],
    }),
    shared: (offerId: string) => ({
        queryKey: [{ offerId }],
        queryFn: () => getSharedScheduleList(offerId),
    }),
    reachInformation: (params: ScheduleReachInformationParams) => ({
        queryKey: [{ params }],
        queryFn: () => getReachInformationForScheduleId(params.vesselId, params.scheduleId),
    }),
});
